import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SelectListboxService {
  private readonly activeSelectListbox$$ = signal<string | null>(null);

  constructor() {}

  public readonly activeSelectListbox = computed(() =>
    this.activeSelectListbox$$()
  );

  public setActiveSelectListbox(value: string): void {
    this.activeSelectListbox$$.set(value);
  }

  public close(): void {
    this.activeSelectListbox$$.set(null);
  }
}
